import { imageUrl } from '@helpers/image';
import { Device, from } from '@helpers/media';
import { responsiveSizes } from '@helpers/responsive';
// import { ReactComponent as SvgShamrock } from '@img/general/hta-shamrock.svg';
import { ReactComponent as SvgRssLogo } from '@img/general/rss-petals.svg';
import { ReactComponent as SvgHHLogo } from '@img/icons/HH-icon-unbranded.svg';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import React from 'react';
import S from './HomepageHeroSlide.styles';
const HomepageHeroSlide = ({ active, content, cta1, cta2, image, loading = 'lazy', title, }) => {
    return (React.createElement(S.Container, { initial: active ? 'active' : 'inactive', animate: active ? 'active' : 'inactive', variants: {
            active: {
                opacity: 1,
                pointerEvents: 'all',
                visibility: 'visible',
                display: 'grid',
            },
            inactive: {
                opacity: 0,
                transitionEnd: {
                    pointerEvents: 'none',
                    visibility: 'hidden',
                    display: 'none',
                },
            },
        } },
        React.createElement(S.ContentWrapper, null,
            React.createElement(S.Title, null, title),
            content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
            (cta1 || cta2) && (React.createElement(S.CtaWrapper, null,
                cta1?.text && (React.createElement(LinkButton, { themeOption: "green", href: cta1.url, target: cta1.target, title: cta1.text })),
                cta2?.text && (React.createElement(LinkButton, { themeOption: cta2.themeOption, href: cta2.url, target: cta2.target, title: cta2.text }))))),
        React.createElement(S.ImageWrapper, null,
            React.createElement(S.ImageWrapperInner, null,
                image && (React.createElement("picture", null,
                    React.createElement("source", { media: from(Device.MobileLarge), sizes: "50vw", srcSet: responsiveSizes([{ value: 100, breakpoint: Device.Tablet }, { value: 50 }], image, { mode: 'boxpad' }) }),
                    React.createElement(S.Image, { alt: image?.altText, draggable: false, loading: loading, role: "presentation", src: imageUrl(image, { rmode: 'boxpad', width: 194 }), srcSet: [
                            `${imageUrl(image, { rmode: 'boxpad', width: 194 })} 1x`,
                            `${imageUrl(image, { rmode: 'boxpad', width: 291 })} 1.5x`,
                            `${imageUrl(image, { rmode: 'boxpad', width: 388 })} 2x`,
                            `${imageUrl(image, { rmode: 'boxpad', width: 485 })} 2.5x`,
                            `${imageUrl(image, { rmode: 'boxpad', width: 582 })} 3x`,
                        ].join(',') }))),
                React.createElement(S.HHGraphicWrapper, null,
                    React.createElement(S.Graphic1, { as: SvgHHLogo }),
                    React.createElement(S.Graphic2, { as: SvgHHLogo }))),
            React.createElement(S.RssGraphicWrapper, null,
                React.createElement(S.Graphic1, { as: SvgRssLogo })))));
};
export default HomepageHeroSlide;
